// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ actions
const loginAsClient = require('actions/contactCenter/loginAsClient');
const profileActions = require('actions/profile');
const translations = require('actions/translations');

// @ components
const LoginAsClientView = require('components/myProfile/loginAsClient/loginAsClientView');

class LoginAsClientViewContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.immLoginAsClient.get('hasBeenFetch')) {
            this.props.history.push('/myprofile/global')
        }
    }

    render() {
        return (
            <LoginAsClientView {...this.props} />
        );
    }
}

LoginAsClientViewContainer.propTypes = {
    history: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object,
    immLoginAsClient: PropTypes.object,
    immTranslations: PropTypes.object,
    requestClientPinValidation: PropTypes.func,
    requestGetProfile: PropTypes.func,
    requestTranslations: PropTypes.func.isRequired
};

module.exports.LoginAsClientViewContainer = connect(state => ({
    immProfileFields: state.profile,
    immLoginAsClient: state.loginAsClient,
    immTranslations: state.translations
}), {
    requestClientPinValidation: loginAsClient.validateClientPin,
    requestGetProfile : profileActions.requestProfile,
    requestTranslations: translations.requestTranslations
})(withRouter(LoginAsClientViewContainer));
